import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FileSizeService } from 'src/app/services/file-size.service';

@Component({
  selector: 'app-view-project-info-modal',
  templateUrl: './view-project-info-modal.page.html',
  styleUrls: ['./view-project-info-modal.page.scss'],
})
export class ViewProjectInfoModalPage implements OnInit {

  public project: any = {};

  constructor(public modalController: ModalController,
    public fileSizeService: FileSizeService) { }

  ngOnInit() {
    document.getElementById('closeBtn').focus();
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  getProjectSize(projectSize){
    return this.fileSizeService.getProjectSizeWithMetric(projectSize);
  }

}
